import { ReactElement } from 'react';
import {
  DocumentationViewItem,
  isDirectoryItemType,
} from 'store/documentation/model/types';
import { DocumentationRowIcon } from '../../DocumentationIcon';
import { Box, Typography } from '@mui/material';
import { isArchived } from '../model';

export function DocumentationNameWithIconCell({
  cellData: name,
  rowData,
}: {
  cellData: string;
  rowData: DocumentationViewItem;
}): ReactElement {
  const isRowArchived = isArchived(rowData);
  const isEmptyActiveDirectory =
    isDirectoryItemType(rowData.type) &&
    !isRowArchived &&
    (rowData as DocumentationViewItem & { isEmptyDirectory?: boolean })
      .isEmptyDirectory === true;
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        gap: 2,
        paddingLeft: 1,
        width: '100%',
        height: '100%',
        overflow: 'hidden',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>
        <DocumentationRowIcon
          type={rowData.type}
          disabled={isRowArchived}
          isEmptyDirectory={isEmptyActiveDirectory}
        />
      </Box>
      <Typography
        variant='body2'
        sx={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          flex: 1,
          lineHeight: 1,
        }}
      >
        {name}
      </Typography>
    </Box>
  );
}
